export const Orderendpoint = {
  buyNow: "/buyNow",
  getInstallments: "/getInstallments",
  verify: "/verify",
  payInstallment: "/payInstallment",
  orderList: "/list",
  verifyCoupon: "/verifyCoupan",
};
